<template>
  <div class="HubOutputSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubOutputSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubOutputSettings-main lxn-pos-rel">
      <div class="HubOutputSettings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{getType === 'internal' ? $store.getters.language.texts.HubOutputSettings_title1 : getType === 'expansion1' ? $store.getters.language.texts.HubOutputSettings_title2 : $store.getters.language.texts.HubOutputSettings_title3}}
          </template>
          <template v-slot:body>
            <div class="HubOutputSettings-wrapper-inputs lxn-margin-auto lxn-border-round">
              <div class="HubOutputSettings-input-spacer">
              </div>
              <div class="lxn-w100 lxn-display-flex-center lxn-margin-bottom-10 lxn-gap15" v-for="(inp, index) in getOutputs">
                <div class="lxn-w5 lxn-lineH-50px lxn-text-center">Y{{index + 1}}</div>
                <div class="lxn-w50">
                  <customInput v-model="inp.name" bgColor="#FFFFFF" inputType="text">
                  </customInput>
                </div>
                <div class="lxn-w45">
                  <select  class="HubOutputSettings-dropdown lxn-border-round" v-model="inp.type">
                    <option  value="">انتخاب</option>
                    <option v-for="t in dropDownOutputType" :key="t.value" :value="t.value">{{t.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="HubOutputSettings-button lxn-margin-auto lxn-w100 " style="margin-top: 20px">
              <CustomButton @click="saveOutputs" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
                {{$store.getters.language.texts.HubOutputSettings_button}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomInput from "@/components/CustomInput";
import DropDown from "@/components/DropDown";
import NODES from "@/statics/devices/Nodes";

export default {
  name: 'HubOutputSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    CustomInput,
    TitleBox,
    ButtonIcon,
    DropDown
  },
  data: function () {
    const node = this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    const length = (this.$route.params.type === 'internal')? 8: 16;
    const param_base_idx = (this.$route.params.type === 'expansion1')? 8: (this.$route.params.type === 'expansion2')? 24: 0;
    var outputs = Array.from({length: length}, (_, i) => {
      return (node.outputs[param_base_idx + i]? 
        node.outputs[param_base_idx + i]: 
        (() => {
          const x = NODES[2][`OUTPUT${param_base_idx + i + 1}`];
          return {
            type: x.TYPE,
            name: this.$store.getters.language.texts[x.NAME],
            icon: x.ICON,
            parameterId: x.PARAMETER_ID,
            settings: {
              outputType: 0,
              unitType: this.$route.params.type
            }
          };
        })()
      );
    });
    console.log(outputs);
    return {
      node: node,
      type: this.$route.params.type,
      activeBoxIndex: node.color,
      outputs: outputs,
      param_base_idx: param_base_idx
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    getType: function () {
      return this.type;
    },
    getOutputs: function () {
      return this.outputs;
    },
    dropDownOutputType: function () {
      return [
        {
          name: this.$store.getters.language.texts.HubOutputSettings_typeLights,
          value: 'RelaySSR2A'
        },
        {
          name: this.$store.getters.language.texts.HubOutputSettings_typeHVAC,
          value: 'HVAC'
        },
        {
          name: this.$store.getters.language.texts.HubOutputSettings_typeCurtain,
          value: 'Curtain'
        },
        {
          name: this.$store.getters.language.texts.HubOutputSettings_typeSecurity,
          value: 'Security'
        },
        {
          name: this.$store.getters.language.texts.HubOutputSettings_typeCoolingAndHeating,
          value: 'CoolingAndHeating'
        },
        {
          name: this.$store.getters.language.texts.HubOutputSettings_typeOthers,
          value: 'Others'
        },
      ]
    },
  },
  methods: {
    toggleNormalState: function (inp) {
      if(inp.normalState === 'on'){
        inp.normalState = 'off';
      }else{
        inp.normalState = 'on';
      }
    },
    toggleTypeState: function (inp) {
      if(inp.typeState === 'on'){
        inp.typeState = 'off';
      }else{
        inp.typeState = 'on';
      }
    },
    goBack: function () {
      this.$router.push('/hubIOSettings/' + this.node.uuid + '/' + this.type);
    },
    saveOutputs: function () {
      this.$store.commit('setHubOutputs', {
        uuid: this.node.uuid,
        type: this.type,
        outputs: this.outputs.map((x, idx) => ({
          ...x,
          type: this.type,
        }))
      });
      this.$store.commit('saveState');
      const outputs = this.outputs.filter(x => (x.name !== undefined && x.name !== null && x.name !== ''));
      setTimeout(() => {
        outputs.forEach((x, idx) => {
          this.$store.commit("addWidget", {
            name: x.name,
            color: this.node.color,
            type: "singleSwitchWidget",
            hubUUID: this.node.hubUUID,
            nodeUUIDs: [this.node.uuid],
            visible: true,
            settings: {
              outputIndex: this.param_base_idx + idx,
              parameterId: x.parameterId
            },
          });
        });
        this.$store.commit('saveState');
      }, 100);
      this.goBack();
    },
  }
}
</script>

<style>
.HubOutputSettings-topCurve-wrapper {
  height: 200px;
}
.HubOutputSettings-main {
  z-index: 2;
}
.HubOutputSettings-main-wrapper {
  min-height: 150px;
  width: calc(100% - 36px);
  margin-top: -150px;
  background-color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}
.HubOutputSettings-wrapper-users {
  height: 50px;
  background-color: #FFFFFF;
  margin-top: 14px;
}
.HubOutputSettings-wrapper-inputs {
  width: 100%;
  margin-bottom: 14px;
}
.HubOutputSettings-input-spacer {
  height: 16px;
}
.HubOutputSettings-button {
  width: 100%;
}
.HubOutputSettings-dropdown {
  width: 100%;
  height: 50px;
  background-color: white;
  border: unset;
  box-shadow: unset;
  text-align: center;
}
</style>
